const listerScoreBannerClicked = () => {};

const listerMetricsBannerClicked = () => {};

const overviewShown = () => {};

const recommendationsClicked = () => {};

const analyticsClicked = () => {};

const verifiedBankAccountBannerClicked = () => {};

const otherListingsClicked = () => {};

const paymentGuaranteedTestShown = () => {};

const paymentGuaranteedTestClicked = () => {};

const recommendationsTrackingEvents = () => {
  return {
    analyticsClicked,
    listerScoreBannerClicked,
    listerMetricsBannerClicked,
    overviewShown,
    recommendationsClicked,
    verifiedBankAccountBannerClicked,
    otherListingsClicked,
    paymentGuaranteedTestShown,
    paymentGuaranteedTestClicked,
  };
};

export default recommendationsTrackingEvents;
